import styles from "./First.module.scss";

export const FirstPage = () => {
    return (
        <section className={styles.first}>
            <div className={styles.quoteWrapper}>
                <div className={styles.quote}>
                    I want people to understand that happiness and success are
                    not a matter of chance, but a result of the right mindset,
                    behavior, and inner harmony.
                    <div className={styles.quotesLeft} />
                    <div className={styles.quotesRight} />
                </div>
            </div>
        </section>
    );
};
